var exports = {
  "xE": "WarningAlert.module__alert___blJCaE",
  "Kk": "WarningAlert.module__icon___blJCaE",
  "Qs": "WarningAlert.module__content___blJCaE",
  "DD": "WarningAlert.module__title___blJCaE",
  "Qq": "WarningAlert.module__text___blJCaE",
  "nf": "WarningAlert.module__link___blJCaE",
  "o1": "WarningAlert.module__actions___blJCaE",
};

module.exports = exports;
